import { render } from "./Product Purchase.vue?vue&type=template&id=71e76aa6"
import script from "./Product Purchase.vue?vue&type=script&lang=js"
export * from "./Product Purchase.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__